import { render, staticRenderFns } from "./editTaskDetail.vue?vue&type=template&id=665fd1bb&scoped=true"
import script from "./editTaskDetail.vue?vue&type=script&lang=js"
export * from "./editTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./editTaskDetail.vue?vue&type=style&index=0&id=665fd1bb&prod&lang=scss"
import style1 from "./editTaskDetail.vue?vue&type=style&index=1&id=665fd1bb&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fd1bb",
  null
  
)

export default component.exports